import { CheckNotes, InspectionCase } from '../../inspection-cases';
import { FireExtinguishingPumps } from './fire-extinguishing-pumps.dto';
import { FireExtinguishingReservoir } from './fire-extinguishing-reservoir.dto';

export class PumpRoomDesignDto extends InspectionCase {
  fireExtinguishingPumps?: FireExtinguishingPumps;
  fireExtinguishingReservoir?: FireExtinguishingReservoir;
}

export class PumpRoomDesign extends PumpRoomDesignDto {
  constructor(
    data: PumpRoomDesignDto = {
      title: 'התקנת חדר משאבות בהתאם לדרישות NFPA-20,22',
      isApplicable: true
    }
  ) {
    super(data);
    this.fireExtinguishingPumps = new FireExtinguishingPumps(
      data.fireExtinguishingPumps
    );
    this.fireExtinguishingReservoir = new FireExtinguishingReservoir(
      data.fireExtinguishingReservoir
    );
  }

  setInspectionStatus(): void {
    this.fireExtinguishingPumps.setInspectionStatus();
    this.fireExtinguishingReservoir.setInspectionStatus();

    this.isPassed =
      this.fireExtinguishingPumps.isPassed &&
      this.fireExtinguishingReservoir.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.fireExtinguishingPumps.getNotes(),
      ...this.fireExtinguishingReservoir.getNotes()
    ];
  }

  setAsApplicable() {
    this.isApplicable = true;
    this.fireExtinguishingPumps.setAsApplicable();
    this.fireExtinguishingReservoir.setAsApplicable();
  }
}
